import { render } from "./RomaneioRelatorio.vue?vue&type=template&id=7a23325d&scoped=true"
import script from "./RomaneioRelatorio.vue?vue&type=script&lang=js"
export * from "./RomaneioRelatorio.vue?vue&type=script&lang=js"

import "./RomaneioRelatorio.vue?vue&type=style&index=0&id=7a23325d&scoped=true&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a23325d"]])

export default __exports__